import type { Route } from 'next';

import { AspectRatio } from '../AspectRatio';

import { MediaLivestreamStatus } from './LiveStreamStatus';
import { MediaOverlay } from './Shared/MediaOverlay';
import { useLivestreamUpdateStatus } from './use-livestream-countdown';

type Props = {
	image: {
		link?: Route | null | undefined;
		altText?: string | null | undefined;
		copyright?: string | null | undefined;
		url?: string | null | undefined;
		title?: string | null | undefined;
		isPriority?: boolean;
		sizes: string;
	};
	livestream: {
		rowId: number;
		start?: string | null | undefined;
		end?: string | null | undefined;
		hls?: string | null | undefined;
		hasRecordings: boolean;
	};
	dense?: boolean;
	className?: string;
};

export function LiveStreamOverlay({
	image: { link, isPriority, sizes, copyright, altText, url, title },
	livestream: { rowId, start, end, hls, hasRecordings },
	className = '',
	dense = false,
}: Props) {
	const { startDate: livestreamStartDate, endDate: livestreamEndDate } = useLivestreamUpdateStatus(
		rowId,
		start ?? null,
		end ?? null,
		0,
		hls ?? null,
		[]
	);

	return (
		<AspectRatio as="figure" className={className}>
			<MediaOverlay
				thumbnailLink={link}
				thumbnailAltText={altText}
				thumbnailCopyright={copyright}
				thumbnailUrl={url}
				thumbnailTitle={title ?? undefined}
				isPriority={isPriority}
				showPlayButton={false}
				buttonVariant="livestream"
				isHero={false}
				enableZoomEffect={true}
				sizes={sizes}
			>
				<MediaLivestreamStatus startDate={livestreamStartDate} endDate={livestreamEndDate} hasRecordings={hasRecordings} dense={dense} />
			</MediaOverlay>
		</AspectRatio>
	);
}
